var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8V13C18 15.7614 15.7614 18 13 18H8C5.23858 18 3 15.7614 3 13V8C3 5.23858 5.23858 3 8 3H13C15.7614 3 18 5.23858 18 8Z",
    stroke: "#1C38F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83325 10.5C7.45254 10.5 6.33325 11.6193 6.33325 13C6.33325 14.3807 7.45254 15.5 8.83325 15.5C10.214 15.5 11.3333 14.3807 11.3333 13V5.5C11.611 6.33333 12.6666 8 14.6666 8",
    stroke: "#1C38F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.053ea378d22d4f5e5a047b24042f9fff.svg";
export { ForwardRef as ReactComponent };